import React, {useState} from 'react';
import {withNamespaces} from 'react-i18next';
import config from '../../../../../../config';
import {Container, Toggler, Box} from './styles';

function DataNotice({t}) {
  const [show, setShow] = useState(false);

  function toggleBox() {
    setShow(!show);
  }

  return (
    <Container>
      <Toggler onClick={toggleBox}>
        {t('dataNotice.label')}
      </Toggler>
      {
        show ? (
          <Box>
            {t('dataNotice.content', {brand: config.brand})}
          </Box>
        ) : null
      }
    </Container>
  );
}

export default withNamespaces()(DataNotice);